import { useEffect, useRef, useState } from "react";

// Style
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Search } from "lucide-react";

// Enum

// Library
import "flatpickr/dist/themes/airbnb.css";
import useGetQueryhr from "hooks/useGetQueryhr";
import { useRecoilState } from "recoil";
import { groupSearchValueAtom } from "recoil/store";
export default function SearchGroupList({ setParamValues }) {
  const [searchValue, setSearchValue] = useRecoilState(groupSearchValueAtom);

  const searchRef = useRef(searchValue.groupFind);

  const handleSubmitValues = (e) => {
    const { name, value } = e.target;
    setSearchValue((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    searchRef.current.focus();
  }, []);

  const submitSearch = () => {
    const groupFind = searchRef?.current?.value || "";

    let submit = {
      groupFind: groupFind || null,
      roomUseYN: searchValue.roomUseYN === "TOTAL" || searchValue.roomUseYN === "" ? null : searchValue.roomUseYN,
      companyIdx: searchValue.companyIdx === "all" || searchValue.companyIdx === "" ? null : searchValue.companyIdx,
    };

    setSearchValue(submit);

    setParamValues({ pageNo: 1, ...submit });
  };

  const { data, pageInfo, isLoading, isFetching } = useGetQueryhr("allCompanies");

  const [companyList, setCompanyList] = useState([]);

  useEffect(() => {
    if (data) {
      const companiesWithAllOption = [{ companyIdx: "all", companyCode: "all", companyName: "전체" }, ...data];
      setCompanyList(companiesWithAllOption);
    }
  }, [data]);

  return (
    <Grid container columnGap={1}>
      <TextField select label="감독방식" size="small" name="roomUseYN" onChange={handleSubmitValues} value={searchValue?.roomUseYN} sx={{ minWidth: 100 }}>
        <MenuItem key={"total"} value={"TOTAL"}>
          전체
        </MenuItem>
        <MenuItem key={"Y"} value={"Y"}>
          화상감독
        </MenuItem>
        <MenuItem key={"N"} value={"N"}>
          무감독
        </MenuItem>
      </TextField>
      <TextField select label="고객사" size="small" name="companyIdx" onChange={handleSubmitValues} value={searchValue?.companyIdx} sx={{ minWidth: 100 }}>
        {companyList?.map((company) => (
          <MenuItem key={company.companyIdx} value={company.companyIdx || "all"}>
            {company.companyName}
          </MenuItem>
        ))}
      </TextField>

      <Grid item>
        <TextField
          size="small"
          inputRef={searchRef}
          defaultValue={searchValue.groupFind}
          sx={{ minWidth: 300 }}
          placeholder="공고명 또는 검사시작 날짜를 입력해주세요"
          onKeyDown={(e) => {
            if (e.key === "Enter") submitSearch();
          }}
        />
      </Grid>
      <Grid item>
        <Button startIcon={<Search size={15} />} sx={{ height: "100%" }} variant={"outlined"} onClick={submitSearch}>
          검색
        </Button>
      </Grid>
    </Grid>
  );
}
